// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateCustomSlideContentSubscriptionVariables = Types.Exact<{
  input: Types.GeneratePresentationCustomSlidePromptInput;
}>;


export type GenerateCustomSlideContentSubscription = { __typename?: 'Subscription', generatePresentationCustomSlidePrompt: { __typename?: 'PresentationCustomSlidePromptResult', textDelta?: string | null, isComplete: boolean, error?: string | null, generatedContent?: string | null } };

export const Operations = {
  Subscription: {
    GenerateCustomSlideContent: 'GenerateCustomSlideContent' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateCustomSlideContentDocument = gql`
    subscription GenerateCustomSlideContent($input: GeneratePresentationCustomSlidePromptInput!) {
  generatePresentationCustomSlidePrompt(input: $input) {
    textDelta
    isComplete
    error
    generatedContent
  }
}
    `;

/**
 * __useGenerateCustomSlideContentSubscription__
 *
 * To run a query within a React component, call `useGenerateCustomSlideContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomSlideContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateCustomSlideContentSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCustomSlideContentSubscription(baseOptions: Apollo.SubscriptionHookOptions<GenerateCustomSlideContentSubscription, GenerateCustomSlideContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GenerateCustomSlideContentSubscription, GenerateCustomSlideContentSubscriptionVariables>(GenerateCustomSlideContentDocument, withSubscriptionIgnoreResults(options));
      }
export type GenerateCustomSlideContentSubscriptionHookResult = ReturnType<typeof useGenerateCustomSlideContentSubscription>;
export type GenerateCustomSlideContentSubscriptionResult = Apollo.SubscriptionResult<GenerateCustomSlideContentSubscription>;